import { render, staticRenderFns } from "./SlotImg.vue?vue&type=template&id=2d46be47&"
import script from "./SlotImg.vue?vue&type=script&lang=js&"
export * from "./SlotImg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports